/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TaxCategoryAssociationsRequest } from '../../models/tax-category-associations-request';
import { TaxCategoryAssociationsUpdateResponse } from '../../models/tax-category-associations-update-response';

export interface TaxCategoriesAssociationsPut$Params {
  'Active-Tenant-Identifier': string;
      body: TaxCategoryAssociationsRequest
}

export function taxCategoriesAssociationsPut(http: HttpClient, rootUrl: string, params: TaxCategoriesAssociationsPut$Params, context?: HttpContext): Observable<StrictHttpResponse<TaxCategoryAssociationsUpdateResponse>> {
  const rb = new RequestBuilder(rootUrl, taxCategoriesAssociationsPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TaxCategoryAssociationsUpdateResponse>;
    })
  );
}

taxCategoriesAssociationsPut.PATH = '/tax-categories/associations';
